import {set} from "./reducer";

/**
 * Sets the user in user-info section of redux.
 */
export const setUserInfoRedux = (user: any) => set(user);
